import { SuggestActionRefreshTheLink } from 'owa-locstrings/lib/strings/suggestactionrefreshthelink.locstring.json';
import loc from 'owa-localize';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { AttachmentModel } from 'owa-attachment-model-store';
import changeAttachmentPermission from 'owa-attachment-model-store/lib/actions/changeAttachmentPermission';
import { refreshSharingTipsForAttachment } from 'owa-attachment-model-store/lib/actions/satchelV3Actions/publicActions';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

import {
    ActionMessageId,
    ActionType,
    AttachmentFullViewState,
    AttachmentMenuAction,
    setOngoingActionAndActionMessage,
} from 'owa-attachment-full-data';

export default function refreshLinkContextMenuItemBuilder(
    attachment: AttachmentFullViewState
): IContextualMenuItem | null {
    const attachmentModel = getAttachment(attachment.attachmentId);

    const refAttachment = attachmentModel.model as ReferenceAttachment;

    if (
        !isFeatureEnabled('doc-attachment-referenceAttachmentExpiration') ||
        !isMenuActionSupported(AttachmentMenuAction.RefreshLink, attachment) ||
        !attachmentCanBeRefreshed(
            attachmentModel,
            refAttachment.PermissionType,
            attachment.isReadOnly
        )
    ) {
        return null;
    }

    return {
        name: loc(SuggestActionRefreshTheLink),
        key: 'Refresh',
        onClick: () => {
            onRefreshMenuItemClicked(attachment, attachmentModel);
        },
    };
}

// This should be calling the refreshExpirationOrchestrator in owa-attachment-model-store,
// but isn't since we need the attachmentViewState to set the action messages, and that
// is only available here.
async function onRefreshMenuItemClicked(
    attachment: AttachmentFullViewState,
    attachmentModel: AttachmentModel
) {
    logUsage('AttachmentContextMenuItemRefreshLink');

    const refAttachment = attachmentModel.model as ReferenceAttachment;

    setOngoingActionAndActionMessage(
        attachment,
        ActionType.Refresh,
        ActionMessageId.RefreshInProgress
    );
    await changeAttachmentPermission([attachmentModel.id], refAttachment.PermissionType);
    refreshSharingTipsForAttachment(attachmentModel.id);
    setOngoingActionAndActionMessage(attachment, ActionType.None, ActionMessageId.None);
}

function attachmentCanBeRefreshed(
    attachment: AttachmentModel,
    currentPermission: AttachmentPermissionLevel,
    isReadOnly: boolean
) {
    return (
        !isReadOnly &&
        attachment &&
        attachment.info &&
        attachment.info.sharingInfo &&
        attachment.info.sharingInfo.expirationDate &&
        attachment.info.supportedPermissionLevels.indexOf(currentPermission) > -1
    );
}
